// extracted by mini-css-extract-plugin
export var dateTimeButton = "_dg-1";
export var dateTimeButtonsContainer = "_dg-6";
export var dateTimeInputContainer = "_dg-7";
export var dateTimeWrapper = "_dg-8";
export var disabledTile = "_dg-0";
export var header = "_dg-2";
export var line = "_dg-3";
export var snoozeOption = "_dg-4";
export var time = "_dg-5";
export var todayTile = "_dg-9";
export var wrapper = "_dg-a";